import { Button, Flex, Typography } from 'antd';
import { v4 as uuidv4 } from 'uuid';

import BankruptcyBoundaryModal, {
  useBankruptcyBoundaryModal,
} from '../../BankruptcyBoundaryModal';
import MakePaymentModal from '../../MakePaymentModal';
import useModalControls from 'hooks/useModalControls';
import OfferCard from './OfferCard';

const { Title } = Typography;

const ChooseOfferStep = ({
  offers,
  hasPendingPayment,
  hasScheduledPayment,
  thirdParty,
}) => {
  const makePaymentModal = useModalControls();
  const {
    bankruptcyBoundaryModal,
    checkBankruptcyBoundary,
    onBankruptcyAcknowledged,
  } = useBankruptcyBoundaryModal(makePaymentModal.show);

  const OfferCards = offers?.map((offer, index) => {
    return (
      <OfferCard
        key={index}
        offer={offer}
        hasPendingPayment={hasPendingPayment}
        hasScheduledPayment={hasScheduledPayment}
        thirdParty={thirdParty}
      />
    );
  });

  return (
    <>
      <Title level={4}>Choose An Offer</Title>
      <Flex
        gap={'var(--spacing-lg)'}
        style={{ marginBottom: 'var(--spacing-sm)' }}
      >
        {offers && OfferCards}
      </Flex>
      <Button size="small" type="text" onClick={checkBankruptcyBoundary}>
        Make an immediate, non-offer payment
      </Button>
      <BankruptcyBoundaryModal
        onBankruptcyAcknowledged={onBankruptcyAcknowledged}
        {...bankruptcyBoundaryModal}
      />
      <MakePaymentModal {...makePaymentModal} paymentUUID={uuidv4()} />
    </>
  );
};

export default ChooseOfferStep;
